export default "__VITE_ASSET__vrcQ5t5M__"